import React, { useState } from "react"
import { Button, Glyphicon } from "react-bootstrap"
import DueDateChangeModal from "./DueDateChangeModal"


export default function MetricsListItem({ assignmentMetric, onDueDateUpdated }) {
  const [showDueDateModal, setShowDueDateModal] = useState(false)
  // Fallback logic: if backend doesn't provide can_edit_due_date, derive from status
  const canEditDueDate = (assignmentMetric && assignmentMetric.can_edit_due_date !== undefined)
    ? assignmentMetric.can_edit_due_date
    : (assignmentMetric && assignmentMetric.status !== "Passed")

  // const renderStatus = () => {
  //   const { status, certificate } = assignmentMetric

  //   if (status === "Passed") {
  //     return (
  //       <Fragment>
  //         {status}
  //         <br/>
  //         <a href={certificate} target="__blank">View Cert.</a>
  //       </Fragment>
  //     )
  //   } else {
  //     return status
  //   }
  // }

  const renderCertificateLink = () => {
    if (assignmentMetric.certificate) {
      return <a href={assignmentMetric.certificate} target="__blank">View Cert.</a>
    } else {
      return <span style={{color: "#b1b1b1"}}>N/A</span>
    }
  }

  const handleDueDateChange = () => {
    setShowDueDateModal(true)
  }

  const handleModalClose = () => {
    setShowDueDateModal(false)
  }

  const handleDueDateUpdateSuccess = () => {
    if (onDueDateUpdated) {
      onDueDateUpdated()
    }
  }

  return (
    <React.Fragment>
      <tr className={`qms-training-table-item`}>
        <td>
          <div>{ assignmentMetric.user }</div>
        </td>
        <td>
          <div>{ assignmentMetric.functional_group }</div>
        </td>
        <td>
          <div>{ assignmentMetric.assessment }</div>
        </td>
        <td>
          <div>{ assignmentMetric.version }</div>
        </td>
        <td>
          <div>{ assignmentMetric.is_published ? "Published" : "Not Published" }</div>
        </td>
        <td>
          <div>{ assignmentMetric.assigned }</div>
        </td>
        <td>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>{ assignmentMetric.due }</span>
            {assignmentMetric.result_id && canEditDueDate && (
              <Button
                bsSize="xsmall"
                bsStyle="link"
                onClick={handleDueDateChange}
                title="Change due date"
                style={{ padding: "0 5px", marginLeft: "5px" }}
              >
                <Glyphicon glyph="pencil" />
              </Button>
            )}
            {assignmentMetric.result_id && !canEditDueDate && (
              <Glyphicon
                glyph="ban-circle"
                title="Cannot change due date after training is passed"
                style={{ color: "#b1b1b1", marginLeft: "5px" }}
              />
            )}
          </div>
        </td>
        <td>
          <div>{ assignmentMetric.completed_date }</div>
        </td>
        <td>
          <div>{ assignmentMetric.status }</div>
        </td>
        <td>
          <div>{ renderCertificateLink() }</div>
        </td>
      </tr>

      {showDueDateModal && (
        <DueDateChangeModal
          show={showDueDateModal}
          onHide={handleModalClose}
          assignmentMetric={assignmentMetric}
          onSuccess={handleDueDateUpdateSuccess}
        />
      )}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/AssignmentMetricsContainer/MetricsListItem.js